export function mediaQuoteSlider() {
    const $slider = $(".media-quote-slider");
    $slider.slick({
        dots: true,
        fade: true,
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/mediaQuoteSlider.js